// extracted by mini-css-extract-plugin
export default {"componentWrapper":"PageTitle_componentWrapper__YvZgp","backArrow":"PageTitle_backArrow__nmjgl","title":"PageTitle_title__9sD5r","thin":"PageTitle_thin__Lxffd"};